import { useEffect, useState } from "react";
import { api, eur } from "../../lib/api";

const STATUS_LABELS = { trial: "Testphase", aktiv: "Aktiv", zahlung_ausstehend: "Zahlung ausstehend", gesperrt: "Gesperrt", gekuendigt: "Gekündigt" };

function Kpi({ label, value, sub }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-xl p-4 shadow-sm">
      <div className="text-[10px] font-mono uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="font-display text-2xl font-semibold tracking-tight mt-1.5" data-testid={`admin-kpi-${label.toLowerCase().replace(/[^a-zäöü]/g, "-")}`}>{value}</div>
      {sub && <div className="text-xs text-zinc-500 mt-1">{sub}</div>}
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div className="text-sm font-mono text-zinc-500">Laden…</div>;

  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <div>
        <div className="text-xs font-mono uppercase tracking-wider text-zinc-500">Plattform</div>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight mt-1">Super-Admin Dashboard</h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Kpi label="Unternehmen" value={stats.tenants} sub={`${stats.new_this_month} neu diesen Monat`} />
        <Kpi label="Aktive Abos" value={stats.by_status.aktiv || 0} sub={`${stats.by_status.trial || 0} in Testphase`} />
        <Kpi label="Gekündigt" value={stats.by_status.gekuendigt || 0} sub={`${stats.by_status.gesperrt || 0} gesperrt`} />
        <Kpi label="Benutzer gesamt" value={stats.users} />
        <Kpi label="Umsatz gesamt" value={eur(stats.revenue_total)} />
        <Kpi label="Umsatz (Monat)" value={eur(stats.revenue_month)} />
        <Kpi label="Offene Zahlungen" value={stats.open_payments} />
        <Kpi label="KI-Imports (Monat)" value={stats.ki_month} sub={`${stats.ki_total} gesamt`} />
      </div>
      <div className="bg-white border border-zinc-200 rounded-xl p-6 shadow-sm">
        <h3 className="font-display font-medium mb-4">Status-Übersicht</h3>
        <div className="flex flex-wrap gap-3">
          {Object.entries(stats.by_status).map(([k, v]) => (
            <div key={k} className="border border-zinc-800 rounded-lg px-4 py-3">
              <div className="text-xs font-mono text-zinc-500">{STATUS_LABELS[k] || k}</div>
              <div className="font-display text-xl font-semibold">{v}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-white border border-zinc-200 rounded-xl p-6 shadow-sm flex items-center justify-between">
        <div>
          <h3 className="font-display font-medium">Systemstatus</h3>
          <p className="text-sm text-zinc-500 mt-1">API, Datenbank und KI-Dienst werden überwacht.</p>
        </div>
        <span className="text-[10px] font-mono bg-emerald-50 text-emerald-700 border border-emerald-200 px-3 py-1 rounded-full" data-testid="system-status-badge">Alle Systeme betriebsbereit</span>
      </div>
    </div>
  );
}
